module.exports = __webpack_public_path__ + "static/media/icon_yewuyunying.31e45a4a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/pageLargeModelSecurity/icon_yewuyunying.svg
// module id = 616
// module chunks = 0